document.addEventListener('DOMContentLoaded', function(){
  const btn = document.querySelector('.burger-btn');
  const drawer = document.getElementById('burger-drawer');
  if(!btn || !drawer) return;

  const panel = drawer.querySelector('.burger-panel');
  const closeEls = drawer.querySelectorAll('[data-burger-close]');
  let lastFocused;

  // Scroll olunca body'ye class (çizgi rengi için)
  document.addEventListener('scroll', () => {
    document.body.classList.toggle('is-scrolled', window.scrollY > 10);
  });

  const open = () => {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    btn.setAttribute('aria-expanded','true');
    setTimeout(()=>{
      const focusable = panel.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])');
      (focusable || panel).focus();
    },0);
    document.addEventListener('keydown', onKey);
    drawer.addEventListener('click', onBackdrop);
  };


  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    btn.setAttribute('aria-expanded','false');
    document.removeEventListener('keydown', onKey);
    drawer.removeEventListener('click', onBackdrop);
    lastFocused && lastFocused.focus();
  };

  const onKey = (e) => { if(e.key === 'Escape') close(); };
  const onBackdrop = (e) => { if(e.target.classList.contains('burger-backdrop')) close(); };

  btn.addEventListener('click', ()=> drawer.classList.contains('is-open') ? close() : open());
  closeEls.forEach(el => el.addEventListener('click', close));
  drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
});




document.addEventListener('DOMContentLoaded', function(){
  const btn = document.querySelector('.mobile-burger-btn');
  const drawer = document.getElementById('mobile-burger-drawer');
  const backdrop = drawer.querySelector('.mobile-burger-backdrop');
  const closeBtn = drawer.querySelector('.mobile-burger-close');

  function openMenu() {
    drawer.classList.add('open');
    backdrop.classList.add('show');
  }

  function closeMenu() {
    drawer.classList.remove('open');
    backdrop.classList.remove('show');
  }

  btn?.addEventListener('click', openMenu);
  closeBtn?.addEventListener('click', closeMenu);
  backdrop?.addEventListener('click', closeMenu);
});




